import styled from "styled-components";

export const MeusAgendamentos = styled.div`
    &[data-project-starcheck="true"] {
        background: #266bf0;

        button {
            background: transparent;
        }
    }
    &[data-project-vlx="true"] {
        background: #000000;

        button {
            background: transparent;
        }
    }
    &[data-project-log="true"] {
        background: #50d05d;

        button {
            background: transparent;
        }
    }
    &[data-project-tokyo="true"] {
        background: #e42e30;

        button {
            background: transparent;
        }
    }
`;

export const NovoAgendamento = styled.div`
    &[data-project-starcheck="true"] {
        background: #e0ebff;
        > div {
            color: #266bf0;
        }

        button {
            background: #266bf0;
        }
    }
    &[data-project-vlx="true"] {
        background: #dbdbdb;
        > div {
            color: #000000;
        }

        button {
            background: #000000;
        }
    }
    &[data-project-log="true"] {
        background: #e9fff2;
        > div {
            color: #50d05d;
        }

        button {
            background: #50d05d;
        }
    }
    &[data-project-tokyo="true"] {
        background: #ffe2e2;
        > div {
            color: #e42e30;
        }

        button {
            background: #e42e30;
        }
    }
`;
